import { getEndpoints } from '../../../utils/appConfig';

export const getExplorerLinks = () => {
    const { mechanicExplorer, tumblerApi } = getEndpoints();
    const links: { text: string; link: string }[] = [];

    if (mechanicExplorer) {
        links.push({ text: "AES Cloud Ops Commands", link: mechanicExplorer });
    }
    links.push({ text: "Tumbler Commands", link: `${tumblerApi}:8443/explorer/` });

    return links;
};

/**
 * localStorage key marking that the Agent Hawk intro popover has been shown.
 * Set once the user dismisses it, so the popover appears only on first load.
 */
export const AGENT_HAWK_INTRO_SEEN_KEY = 'agenthawk-intro-seen';

/** What a user can do with Agent Hawk, shown in the intro popover. */
export const AGENT_HAWK_INTRO_POINTS = [
    'Faster RCAs: describe the symptom and it correlates metrics, insights and events to point at the likely cause of cluster-level issues.',
    'Ask questions about this domain in plain English and get answers grounded in its live data.',
    'Type / to browse quick commands for metrics, cluster, node, index and shard data.',
    'Pull up active insights and recent tickets for the domain, summarised for you.',
    'Skip the tab hunt: it fetches the same data the Tumbler console tabs render.'
];
